/**
 *  interface for Login Type
 */
export enum ForgetPwdTypes {
  FORGET_PASSWORD = '@@forget/FORGET_PASSWORD',
  FORGET_PASSWORD_SUCCESS = '@@forget/FORGET_PASSWORD_SUCCESS',
  FORGET_PASSWORD_ERROR = '@@forget/FORGET_PASSWORD_ERROR',
}
